export default "__VITE_ASSET__BN6WuYqY__";